export default {
  delivery: {
    title: 'Доставка',
    value: 'delivery',
  },
  pickup: {
    title: 'Самовывоз',
    value: 'pickup',
  },
  deliveryTC: {
    title: 'Транспортной компанией',
    value: 'to_transport_company',
  },
  default: {
    title: 'Самовывоз',
    value: 'delivery'
  }
}